import { useCaseService } from "@/hooks/useCaseService";
import { useCallback, useState } from "react";

export interface MedicalChronologyCaseMeta {
  caseName: string | null;
  physicianName: string | null;
  caseStatusId: number | null;
}

export const useMedicalChronologyCaseMeta = (caseId: string) => {
  const caseService = useCaseService();
  const [caseName, setCaseName] = useState<string | null>(null);
  const [physicianName, setPhysicianName] = useState<string | null>(null);
  const [caseStatusId, setCaseStatusId] = useState<number | null>(null);

  const loadCaseMeta = useCallback(async () => {
    const caseDetails = await caseService.getCaseDetails(caseId);
    setCaseName(caseDetails.case_name);
    setPhysicianName(caseDetails.physician_name);
    setCaseStatusId(caseDetails.status_id);
  }, [caseService, caseId]);

  return {
    caseName,
    physicianName,
    caseStatusId,
    loadCaseMeta,
    updateCaseNameLocally: setCaseName,
  };
};
